/* eslint-disable prefer-const */
/**
 * 登录
 */
import { userService } from '@/api'
import { AsyncRequest, TimeLoading } from '@/utils/request'
import { storage } from '@/utils'
import { isWxAndJssdkConfig } from '@/utils/init/wx'
import { getWXUserInfo } from '@/utils/init/env-init'
import { appUser } from '@/utils'
import { getMiniParam } from '@/api/modules/user/mini'
import VConsole from 'vconsole'

// 不需要登录的域名
const siteNotNeedLogin = location.href.indexOf('wx.bnxgn.com') >= 0

const loginInfo = storage.loginCheckCode().getItem()
const state = {
  loginInfo,
  // 验证码的批次
  code: {
    batchID: loginInfo.batchID
  },
  // 登录之后的结果
  result: {
    // request // 请求结果的参数的变量
  },
  // 微信登录的跳转
  toView: {
    hash: ''
  },
  // 当微信登录成功后，衔接跳转流程（业务请使用 appUser ）
  getWXUser: {
    userId: -1
  },
  user: {},
  qrcode: '',
  jssdkConfig: {
    appId: '',
    nonceStr: '',
    signature: '',
    timestamp: ''
  }
}

const getters = {
  // 登录信息、验证码批次号、返回结果
  loginInfo: state => state.loginInfo,
  code: state => state.code,
  result: state => state.result,
  getWXUser: state => state.getWXUser,
  user: state => state.user,
  jssdkConfig: state => state.jssdkConfig,
  qrcode: state => state.qrcode
}

const mutations = {
  // 保存验证码
  setCode: (state, item) => {
    state.code = item
  },
  // 保存检查验证码的结果
  checkCode: (state, result) => {
    state.result = result
    // 登录后记录下用户ID
    state.getWXUser.userFrom = 'checkCode'
    state.getWXUser = {
      userId: result.userModel.userID,
      nickName: result.userModel.nickname,
      mobileNumber: result.userModel.mobileNumber,
      token: result.token
    }
    state.user = state.getWXUser
  },
  userDetail: (state, user) => {
    state.qrcode = user.adviserErCode
  },
  setUser: (state, user) => {
    state.user = {
      userId: user.userId,
      nickName: user.nickName,
      mobileNumber: user.mobileNumber,
      token: user.token,
      code: appUser.code,
      openId: appUser.openId
    }
  },
  clearCode: () => {
    state.code.batchID = ''
  },
  setWXUserInfo: (state, user) => {
    user.code = appUser.code
    state.getWXUser = user || {}
    state.user = state.getWXUser
    console.log('[Login] ', state.getWXUser)
  },
  // 保存微信配置
  setJssdkConfig: (state, config) => {
    state.jssdkConfig = config
  }
}

const actions = {
  // 获取最新小程序配置
  getMiniParam({ commit }, item) {
    return AsyncRequest({
      loading: true,
      request: () => getMiniParam(item),
      resolve: _ => {}
    })
  },
  // 获取验证码
  getCode({ commit }, item) {
    return AsyncRequest({
      loading: true,
      request: () => userService.getCode(item),
      resolve: item => commit('setCode', item)
    })
  },
  // 手机号验证码登录
  checkCode({ commit }, item) {
    storage.loginCheckCode().setItem(item)
    commit('clearCode')
    return AsyncRequest({
      loading: true,
      loadingText: '登录中',
      request: () => userService.checkCode(item),
      resolve: result => {
        result.request = item
        commit('checkCode', result)
      }
    })
  },
  // 获取用户信息
  getUserDetail({ commit }, item) {
    return AsyncRequest({
      request: () => userService.getUserDetail(item),
      resolve: result => {
        commit('userDetail', result)
      }
    })
  },
  // 登录后进入页面（访问之前的操作）
  enterAfterLogin: ({ state }, { action }) => {
    return new Promise((resolve, reject) => {
      const options = storage.loginNextAction().getItem() // 记住业务路由
      if (options.action !== action) {
        reject()
        return
      }
      // 有用户信息
      if (appUser.hasUser() || (state.getWXUser.userId > 0 && state.getWXUser.token)) {
        storage.loginNextAction().remove() // 记住业务路由
        resolve()
      }
      // 仅有微信授权，或者有用户信息（没有token）
      else if (appUser.hasWXUser()) {
        // 页面授权回来后，组件初始化数据后检测（用户信息还没返回）
        // const error = { message: '微信授权失败' }
        if (siteNotNeedLogin) {
          return reject()
        } // 暂时忽略
        // 重新尝试获取WXUser
        // let { openId } = appUser
        // getWXUserInfo({ openId, from: 'enterAfterLogin' })
        //   .then((wxUser = {}) => {
        //     console.log('[getWXUserInfo] resolve', JSON.stringify(wxUser), 'wxUser.openId', wxUser.openId)
        //     // 已经登录成功的，清除业务标记
        //     if (appUser.hasUser()) {
        //       storage.loginNextAction().remove()
        //       resolve()
        //     } else {
        //       appUser.isNotUserToLogin(options) // 继续走登录
        //       reject(error)
        //     }
        //   })
        //   .catch((err) => {
        //     console.log('[getWXUserInfo] reject', JSON.stringify(error), err)
        //     appUser.isNotUserToLogin(options) // 继续走登录
        //     reject(error)
        //   })
        appUser.isNotUserToLogin(options) // 继续走登录
      }
    })
  },
  // 微信登录成功后获取用户信息
  getWXUserInfo: ({ commit }) => {
    return new Promise(resolve => {
      // code 过期后会被清除掉 // 暂时不使用 appUser.hasWXUser()
      const canGetWXUserInfo = appUser.isWeixin && appUser.wxcode && !appUser.hasUser()
      if (canGetWXUserInfo) {
        const loading = TimeLoading('getWXUserInfo')

        console.log('登录中')
        // loading('open', '登录中')
        const { code, openId } = appUser
        // 重新尝试获取WXUser
        getWXUserInfo({ code, openId, from: 'getWXUserInfo' })
          .then((wxUser = {}) => {
            console.log('getWXUserInfo--------->', wxUser, wxUser.code)
            if (wxUser.code) {
              // 正常登陆
              wxUser.userFrom = 'getWXUserInfo'
              commit('setWXUserInfo', wxUser) // 存储用户信息
            }
            loading('close')
            resolve({ loading })
          })
          .catch(() => {
            loading('close')
          })
      }
    })
  },
  // 初始化微信配置
  isWxAndJssdkConfig({ commit }) {
    // 微信初始化
    return isWxAndJssdkConfig()
      .then(config => {
        commit('setJssdkConfig', config)
        return config
      })
      .catch(error => {
        commit('setJssdkConfig', error)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
